




































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import Container from "@/components/Container/Container.vue";
import NavBar from "@/components/NavBar/NavBar.vue";
import Button from "@/components/Button/Button.vue";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
import PriceOfferMap from "@/services/payment/localize/priceOfferMap";
import Jsbridge from "@/jsbridge";
import {base64Object} from "@/api/utils/api_encrypt";
import { getDeviceInfo } from "@/utils/js_bridge_info";
import {handleSucessRouter} from "@/services/payment/super_pay_receive";
import SwitchBackgroundPosition, {
  SwitchPositionTypes
} from "@/utils/switch_background/switch_background_position";
import listenNative from "@/jsbridge/service/listenNative";


@Component({
  components: {
    Container,
    NavBar,
    Button,
    ImgFetched
  }
})
export default class SuperPayPage extends Vue {

  private params: any = {
    auto_renewable: "", // 是否自动订阅
    order_auto_buy: "", // 是否自动购买
    order_image: "", // 购买类型的图片
    order_image_link: "", // 购买类型的图片
    order_information: "", // 购买展示的信息
    order_show_try_for_free: "", // 是否是try for free
    order_source_scheme: "",  // 发起superpay调用的scheme
    order_target_scheme: "",  // 被调的app的scheme
    order_style: "1", // 调起的super pay的ui样式 目前不处理，只展示一种
    price: "", // 价格
    sp_identifier: ""
  };

  get price() {
    return this.isFree ? this.params.price : this.handlePrice(this.params.price);
  }

  get isFree() {
    return Number(this.params.order_show_try_for_free) === 1;
  }

  get order_information() {
    return this.params.order_information;
  }

  get ImgType() {
    const text = this.params.order_information.toLowerCase();
    return text.includes("follow") ?
      "user" : (text.includes("like") || text.includes("comment") || text.includes("view")) ?
        "post" : ""
  }

  get order_image() {
    return this.params.order_image ? "data:image/jpeg;base64," + this.params.order_image : "";
  }

  get buttonText() {
    return this.isFree ? "TRY FOR FREE" : "PAY NOW";
  }

  @Watch("$route", { immediate: true })
  private WatchRouteParam(val: any, oldVal: any) {
    if (
      val &&
      oldVal &&
      val.query &&
      oldVal.query &&
      val.query.t &&
      oldVal.query.t &&
      val.query.t !== oldVal.query.t
    ) {
      this.init();
    }
  }

  private handlePrice(params: string) {
    const type = isNaN(Number(params));
    let unit = "$";
    let price = "";
    if (type) {
      unit = params.substring(0, 1);
      price = params.substring(1);
    } else {
      price = params;
    }
    return {unit, price};
  }

  private clickPay() {
    this.iapPurchase();
  }

  private async iapPurchase() {
    try {
      this.$_Toast.show({
        type: "loading",
        text: "Processing…"
      });
      const auto_renew = Number(this.params.auto_renewable) === 1;
      const key = auto_renew ? "sub_" + this.params.price : "regular_" + this.params.price;
      const priceProductIdList = await PriceOfferMap.getCacheSource();
      console.log("priceProductIdList", priceProductIdList, key);
      // const priceProductIdList = LocalizeUtil.getPriceProductIdList();
      const priceProductResult = priceProductIdList[key];
      console.log("priceProductResult", priceProductResult);
      if (priceProductResult && priceProductResult.product_id) {
        const purchaseResult: any = await Jsbridge.iapPurchase(priceProductResult.product_id, auto_renew);
        this.successCallback(purchaseResult);
      } else {
        this.$_Toast.hide();
        this.$_Toast.show({
          text: "product_id无效"
        });
      }
    } catch (e) {
      console.log("iapPurchase e", e);
      this.$_Toast.hide();
    }
  }

  private goback() {
    let url = this.params.order_source_scheme + "://superpay/jump_failed";
    const params: any = {
      sp_identifier: this.params.sp_identifier,
      error_domain: "SKErrorDomain",
      error_code: 2,
      error_message: "Payment Cancelled"
    };
    Object.keys(params).forEach((key: any, index: number) => {
      url += `${index ? "&" : "?"}${key}=${encodeURIComponent(params[key])}`;
    });
    handleSucessRouter();
    SwitchBackgroundPosition.setPosition(
      SwitchPositionTypes.NOT_REQUIRE_REFRESH
    );
    Jsbridge.openBrowser(url, "system_browser");
  }

  private successCallback(params: any) {
    const {receipt_data, transaction} = params;
    let url = this.params.order_source_scheme + "://superpay/jump_finished";
    const { app_platform, info } = getDeviceInfo();
    const query: any = {
      sp_identifier: this.params.sp_identifier,
      transaction_identifier: transaction && transaction.transaction_identifier,
      receipt_data,
      jump_map: base64Object({pay_platform: app_platform, pay_version: info.short_version})
    };
    Object.keys(query).forEach((key: any, index: number) => {
      url += `${index ? "&" : "?"}${key}=${encodeURIComponent(query[key])}`;
    });
    this.$_Toast.hide();
    handleSucessRouter();
    SwitchBackgroundPosition.setPosition(
      SwitchPositionTypes.NOT_REQUIRE_REFRESH
    );
    Jsbridge.openBrowser(url, "system_browser");
  }

  private created() {
    listenNative.addListen(
      "did_enter_background",
      () => {
        handleSucessRouter();
      },
      { key: "super_pay_page" }
    );
    this.init();
  }

  private init() {
    const params: any = this.$route.query.params;
    this.params = params && JSON.parse(params);
    console.log("superPayReceive params", this.params);
    if (Number(this.params.order_auto_buy) === 1) {
      this.iapPurchase();
    }
  }

  // 组件销毁前必须去除对app进入前台事件的监听
  private beforeDestroy() {
    listenNative.removeListen("super_pay_page");
  }
}
